// returns kebob-case

const sanitizeValue = value => {
  const sanitizedValue = value.replace(/\s+/g, '-').replace(/_+/g, '-').replace(/[!@#$%^&*,]/g, '').toLowerCase();
  return sanitizedValue;
};
export default sanitizeValue;